import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import bridge from '@vkontakte/vk-bridge';
// Import the functions you need from the SDKs you need
import {ref, set, get} from 'firebase/database';
import {
  Div,
  Panel,
  PanelHeader,
  Group,
  SubnavigationBar,
  SubnavigationButton,
  Button,
} from '@vkontakte/vkui';
import statCore from '../ok/stat';

import api from '../ok/core';
// Import db from '../ok/db';
import launchState from '../ok/launchState';

import {Icon as SignIcon} from '../components/icon/icon.js';

import okdata from './data.json';

import './Sign.css';

const Sign = ({
  id,
  sign,
  go,
  okUserId,
  getDB,
  isInitiallyNotificationsEnabled,
  setIsInitiallyNotificationsEnabled,
  isNotificationsEnabled,
  setIsNotificationsEnabled,
}) => {
  const [dateType, setDateType] = useState('today');
  const isSharedToday = launchState.getIsSharedToday(okUserId);

  const [isShared, setIsShared] = useState(isSharedToday);

  const [text, setText] = useState('');
  const [date, setDate] = useState('');

  async function enableNotifications() {
    const prefix = okUserId.toString().startsWith('vk') ? 'vkusers/' : 'users/';
    try {
      const data = await bridge.send('VKWebAppAllowNotifications');
      if (data.result) {
        if (okUserId) {
          try {
            set(ref(getDB(okUserId), prefix + okUserId), sign.index);
            statCore.log('horo-subscribe-link');
            statCore.log('horo-subscribe');
            // Db.okuser.store({
            //   ownerUserId: okUserId,
            // });
          } catch {}
        }

        launchState.setIsNotificationsEnabled(okUserId, true);
        setIsNotificationsEnabled(true);
      }
    } catch {
      //
    }
  }

  async function shareHoro(text, sign, date, decoratorId) {
    const shareText = `Гороскоп для ${sign} на ${date}:

    ${text}`;
    const mediaData = [
      {
        text: shareText,
        type: 'text',
      },
    ];
    try {
      await api.call({
        method: 'mediatopic.post',
        type: 'USER_NOTE',
        attachment: {
          motivator_id: decoratorId,
          media: mediaData,
        },
      });
      launchState.setIsSharedToday(okUserId, true);
      setIsShared(true);
      statCore.log('horo-shared');
    } catch (err) {
      try {
        bridge.send('VKWebAppShowWallPostBox', {message: shareText});
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    const fetchRef = async () => {
      const response = await fetch("https://okoscope.vercel.app/data.json");
      const okdata = await response.json();
      const selectedSign = okdata[dateType].data.find((element) => {
        const title = element.title.toLowerCase();
        return title.includes(sign.title.toLowerCase());
      });
      const signscope = selectedSign?.description ?? '';
      setText(signscope);
      setDate(okdata[dateType].date);
    };

    fetchRef();
  }, [dateType, sign]);

  return (
    <Panel id={id} sizeX="compact">
      <PanelHeader
        left={
          <Div data-to="home" onClick={go}>
            <SignIcon name="back" style={{marginTop: '2'}} />
          </Div>
        }
      >
        {sign.title}
      </PanelHeader>
      <Group>
        <SubnavigationBar>
          <SubnavigationButton
            onClick={() => setDateType('today')}
            selected={dateType === 'today'}
          >
            Сегодня
          </SubnavigationButton>
          <SubnavigationButton
            onClick={() => setDateType('tomorrow')}
            selected={dateType === 'tomorrow'}
          >
            Завтра
          </SubnavigationButton>
        </SubnavigationBar>
      </Group>
      <div className="sign__image-wrapper_m">
        <img
          className="sign__image"
          src={`https://st.mycdn.me/static/motivators/1-3-65/5365/${sign.index}m.png`}
        />
      </div>
      <div className="sign__image-wrapper">
        <img
          className="sign__image"
          src={`https://st.mycdn.me/static/motivators/1-3-65/5365/${sign.index}.png`}
        />
      </div>
      <Div>
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{__html: text}} />
      </Div>
      <div className="sign__buttons">
        <Div>
          {isShared ? (
            'Вы поделились'
          ) : (
            <Button
              align="left"
              mode="primary"
              onClick={() =>
                shareHoro(text, sign.title_r, date, sign.decorator_id)
              }
            >
              Поделиться с друзьями
            </Button>
          )}
        </Div>
        {isInitiallyNotificationsEnabled && isNotificationsEnabled ? null : (
          <Div>
            {isNotificationsEnabled ? (
              'Вы подписались на гороскоп'
            ) : (
              <Button
                align="left"
                mode="secondary"
                onClick={() => enableNotifications()}
              >
                Подписаться на гороскоп
              </Button>
            )}
          </Div>
        )}
      </div>
    </Panel>
  );
};

Sign.propTypes = {
  id: PropTypes.string.isRequired,
  go: PropTypes.func.isRequired,
  sign: PropTypes.shape({
    icon: PropTypes.string,
    index: PropTypes.number,
    decorator_id: PropTypes.number,
    title: PropTypes.string,
    title_r: PropTypes.string,
    date: PropTypes.string,
  }),
  okUserId: PropTypes.string,
  database: PropTypes.object,
};

export default Sign;
